import TimerIcon from '@mui/icons-material/Timer'
import { Paper, Typography } from '@mui/material'
import { Duration } from 'luxon'
import { useTranslate } from 'ra-core'
import { DateField, useLocaleState, useRecordContext } from 'react-admin'

import { HeaderSection, InfoWindowDivider } from './AdvancedInfoWindow'
import CurrentBookingField from './CurrentBookingField'
import EventTimeline from './EventTimeline'
import FieldRow from './FieldRow'
import LocationField from './LocationField'

const StationaryEventSection = () => {
  const { started_on, ended_on } = useRecordContext()
  const [locale] = useLocaleState()
  const translate = useTranslate()
  const start = new Date(started_on).getTime()
  const end = ended_on === null ? Date.now() : new Date(ended_on).getTime()
  const durationInSeconds = Math.round((end - start) / 60000)

  const formattedDuration = Duration.fromObject({ minutes: durationInSeconds }, { locale })
    .shiftTo('days', 'hours', 'minutes')
    .normalize()
    .toHuman({ showZeros: false })

  return (
    <>
      <Paper variant="outlined" sx={{ p: 1.5, borderRadius: 2, borderColor: '#0000001f', backgroundColor: '#FAFAFB' }}>
        <FieldRow
          icon={TimerIcon}
          helperText={
            <Typography variant="caption" sx={{ opacity: 0.7 }}>
              <DateField source="started_on" showTime />
              <Typography component="span" sx={{ mx: 1, opacity: 0.6 }}>
                →
              </Typography>
              <DateField source="ended_on" showTime emptyText={translate('mymove.ongoing')} />
            </Typography>
          }
        >
          <Typography sx={{ fontWeight: 400, lineHeight: 1.1 }}>{formattedDuration}</Typography>
        </FieldRow>

        <InfoWindowDivider />
        <LocationField />
        <CurrentBookingField />
      </Paper>
      <HeaderSection title="timeline" />
      <InfoWindowDivider />
      <EventTimeline />
    </>
  )
}

export default StationaryEventSection
